import * as React from 'react';
import { IInjectedProps } from '../../interface/component/injected-props.interface';
import { animatedSvg } from '../decorators/animated-svg';
import { asyncComponent } from '../async-component/async-component';
import { inject, observer } from 'mobx-react';
import { BlockColorType } from '../../enum/block-color.enum';

const ThreeDots = asyncComponent(() => import('./three-dots').then(module => module.ThreeDots));
const Puff = asyncComponent(() => import('./puff').then(module => module.Puff));
const Grid = asyncComponent(() => import('./grid').then(module => module.Grid));
const Pen = asyncComponent(() => import('./pen').then(module => module.Pen));
const MagicRing = asyncComponent(() => import('./magic-ring').then(module => module.MagicRing));
const Bullet = asyncComponent(() => import('./bullet').then(module => module.Bullet));
const DotLoader = asyncComponent(() => import('./dot-loader').then(module => module.DotLoader));
const SimpleSpinner = asyncComponent(() => import('./simple-spinner').then(module => module.SimpleSpinner));
const FadeOutSpinner = asyncComponent(() => import('./fade-out-spinner').then(module => module.FadeOutSpinner));

export const SpinnersArray = [ ThreeDots, Puff, Grid, Pen, MagicRing, Bullet, DotLoader, SimpleSpinner, FadeOutSpinner ];

interface ILoaderProps {
  height: number;
  width: number;
  spinner?: number;
  style?: React.CSSProperties;
  color?: BlockColorType;
}

@animatedSvg
@inject('state')
@observer
export default class Loader extends React.Component<ILoaderProps & IInjectedProps> {
  render() {
    const spinner = this.props.spinner === undefined ? this.props.state.configuration.settings.spinnerConfig.spinner : this.props.spinner;
    const color = this.props.color || this.props.state.configuration.settings.spinnerConfig.spinnerColor;
    const Component = SpinnersArray[ spinner - 1 ];
    return <Component
      width={this.props.width}
      height={this.props.height}
      color={this.props.state.colors.getColor(color)}
      style={this.props.style}
    />;
  }
}
